import React from 'react';
import PropTypes from 'prop-types';
import {PRODUCT_FRAGMENT} from "../productPreview/ProductPreview";
import {gql} from "@apollo/client";
import {useQuery} from "@apollo/client";
import SimilarProductList from "./SimilarProductList";

export const NUM_OF_SIMILAR_PRODUCTS = 6;
const GET_SIMILAR_PRODUCTS = gql`
  query getSimilarProducts($productIds: [Int!]!, $limit: Int) {
    getSimilarProducts(productIds: $productIds, limit: $limit) {
        related_products {
            ...ProductFragment   
        }
    }
  }
  ${PRODUCT_FRAGMENT}
`;

/**
 * 비슷한 상품 API 호출 및 렌더링을 담당하는 컴포넌트
 * @param productId
 * @param showMoreButton 더보기 버튼 노출 여부 (기본 true)
 * @param emptyFallback 비슷한 상품이 없을 때 대신 렌더할 노드 (기본 null)
 * @returns {Element}
 * @constructor
 */
export default function SimilarProductQueryWrapper({productId, showMoreButton = true, emptyFallback = null}) {
    const {data, error, loading} = useQuery(GET_SIMILAR_PRODUCTS, {
        variables: {
            limit: NUM_OF_SIMILAR_PRODUCTS,
            productIds : [Number(productId)],
        },
        ssr: true,
    });

    // 로딩 중에는 아직 결과가 비었는지 알 수 없으므로 fallback을 렌더하지 않는다.
    if (loading) {
        return null;
    }

    const relatedProducts = data?.getSimilarProducts?.[0]?.related_products ?? [];

    if (error || relatedProducts.length === 0) {
        return emptyFallback;
    }

    return (
        <div className={"SimilarProductList-container"}>
            <span className={"SimilarProductList-title"}>비슷한 상품</span>
            <SimilarProductList products={relatedProducts} limit={NUM_OF_SIMILAR_PRODUCTS} showMoreButton={showMoreButton} />
        </div>
    );
}

SimilarProductQueryWrapper.propTypes = {
    productId: PropTypes.string.isRequired,
    showMoreButton: PropTypes.bool,
    emptyFallback: PropTypes.node
}
